import { BasicComponent, ComponentAttributeBinder, View } from '@ribajs/core'
import { TwAbstractBreakpointBinder } from '../types/tw-abstract-breakpoint.binder.js'

/**
 * Responsive component attribute breakpoint binder
 * This binder is used to pass attributes to an Riba Component (directly) that should only be set at certain breakpoints (viewport widths).
 * @example
 * ```html
 *  <custom-image-component
 *    rv-tw-co-xxs-src="'https://picsum.photos/100'"
 *    rv-tw-co-xs-src="'https://picsum.photos/200'"
 *    rv-tw-co-sm-src="'https://picsum.photos/500/200'"
 *    rv-tw-co-md-src="'https://picsum.photos/1000/500'"
 *
 *    rv-tw-co-xxs-alt="'Image for very small displays'"
 *    rv-tw-co-xs-src="'Image for small displays'"
 *    rv-tw-co-sm-src="'Image for smartphones'"
 *    rv-tw-co-md-src="'Image for tablets and small laptops'"
 *  />
 * ```
 */
export class TwComponentAttributeBreakpointBinder extends TwAbstractBreakpointBinder<BasicComponent> {
  static key = 'tw-co-*-*'

  defaultAttributeBinder: ComponentAttributeBinder

  constructor(
    view: View,
    el: BasicComponent,
    type: string | null,
    name: string,
    keypath: string | undefined,
    formatters: string[] | null,
    identifier: string | null,
  ) {
    super(view, el, type, name, keypath, formatters, identifier)
    this.defaultAttributeBinder = new ComponentAttributeBinder(
      view,
      el,
      `co-${this.attributeName}`,
      name,
      keypath,
      formatters,
      ComponentAttributeBinder.key,
    )
  }
}
